export const BREADCRUMB_OVERFLOW_LENGTH = 5;
export const BREADCRUMB_OVERFLOW_END = 2;
export var POPOVER_PLACEMENTS;
(function (POPOVER_PLACEMENTS) {
    POPOVER_PLACEMENTS["BOTTOM_START"] = "bottom-start";
    POPOVER_PLACEMENTS["BOTTOM_END"] = "bottom-end";
    POPOVER_PLACEMENTS["TOP_START"] = "top-start";
    POPOVER_PLACEMENTS["TOP_END"] = "top-end";
    POPOVER_PLACEMENTS["LEFT_START"] = "left-start";
    POPOVER_PLACEMENTS["LEFT_END"] = "left-end";
    POPOVER_PLACEMENTS["RIGHT_START"] = "right-start";
    POPOVER_PLACEMENTS["RIGHT_END"] = "right-end";
    POPOVER_PLACEMENTS["BOTTOM"] = "bottom";
    POPOVER_PLACEMENTS["TOP"] = "top";
    POPOVER_PLACEMENTS["LEFT"] = "left";
    POPOVER_PLACEMENTS["RIGHT"] = "right";
})(POPOVER_PLACEMENTS || (POPOVER_PLACEMENTS = {}));
export var SINGLELINE_PLACEMENTS;
(function (SINGLELINE_PLACEMENTS) {
    SINGLELINE_PLACEMENTS["BOTTOM_START"] = "bottom-start";
    SINGLELINE_PLACEMENTS["BOTTOM_END"] = "bottom-end";
    SINGLELINE_PLACEMENTS["TOP_START"] = "top-start";
    SINGLELINE_PLACEMENTS["TOP_END"] = "top-end";
    SINGLELINE_PLACEMENTS["BOTTOM"] = "bottom";
    SINGLELINE_PLACEMENTS["TOP"] = "top";
    SINGLELINE_PLACEMENTS["LEFT"] = "left";
    SINGLELINE_PLACEMENTS["RIGHT"] = "right";
})(SINGLELINE_PLACEMENTS || (SINGLELINE_PLACEMENTS = {}));
export var MULTILINE_PLACEMENTS;
(function (MULTILINE_PLACEMENTS) {
    MULTILINE_PLACEMENTS["BOTTOM_START"] = "bottom-start";
    MULTILINE_PLACEMENTS["BOTTOM_END"] = "bottom-end";
    MULTILINE_PLACEMENTS["TOP_START"] = "top-start";
    MULTILINE_PLACEMENTS["TOP_END"] = "top-end";
    MULTILINE_PLACEMENTS["LEFT_START"] = "left-start";
    MULTILINE_PLACEMENTS["LEFT_END"] = "left-end";
    MULTILINE_PLACEMENTS["RIGHT_START"] = "right-start";
    MULTILINE_PLACEMENTS["RIGHT_END"] = "right-end";
})(MULTILINE_PLACEMENTS || (MULTILINE_PLACEMENTS = {}));
//# sourceMappingURL=constants.js.map